<!-- eslint-disable -->
<template lang="pug">
    div
        presentation-preview(
                v-for="profile in items"
                :profile="profile"
                :key="profile.id"
                :opened-theme-id="openedThemeId"
                :selected-presentation-id="selectedPresentationId"
                @open="handleOpenOfTheme"
                @selectPresentation="selectPresentation"
                @startPresentation="startPresentation"
                @deletePresentation="deletePresentation"
                @delete="deleteTheme"
        )
</template>

<script>
    /*eslint-disable*/
    import PresentationPreview from "./Preview.vue";

    export default {
        props: ['items', 'selectedPresentationId'],
        data () {
            return {
                openedThemeId: null,
            }
        },
        methods: {
            handleOpenOfTheme (id) {
                this.openedThemeId = this.openedThemeId === id ? null : id;
            },
            selectPresentation (presentation) {
                this.$emit('selectPresentation', presentation);
            },
            startPresentation (presentation) {
                this.$emit('startPresentation', presentation);
            },
            deletePresentation (id) {
                this.$emit('deletePresentation', id);
            },
            deleteTheme (id) {
                this.$emit('delete', id);
            }
        },
        components: {
            PresentationPreview,
        }
    }
</script>
